export const UPDATE_SELECTED_AGENT_DATA = "UPDATE_SELECTED_AGENT_DATA";
export const UPDATE_ALL_AGENT_DATA = "UPDATE_ALL_AGENT_DATA";
export const UPDATE_MAP_LIST_DATA = "UPDATE_MAP_LIST_DATA";
export const UPDATE_AGENTS_PROPERTY_DATA = "UPDATE_AGENTS_PROPERTY_DATA";
export const UPDATE_PROPERTY_DATA = "UPDATE_PROPERTY_DATA";
export const UPDATE_MARKER_PROPERTY_DATA = "UPDATE_MARKER_PROPERTY_DATA";
export const SET_ZOOM = "SET_ZOOM";
export const SET_CENTER = "SET_CENTER";
export const SET_RECOMMENDATION_SUCCESS = "SET_RECOMMENDATION_SUCCESS";
export const SET_REVIEW_SUCCESS = "SET_REVIEW_SUCCESS";
export const SET_ASK_A_QUESTION_SUCCESS = "SET_ASK_A_QUESTION_SUCCESS";
export const SET_SELECTED_MARKER_AGENT_DATA = "SET_SELECTED_MARKER_AGENT_DATA";
export const SET_ON_CLOSE = "SET_ON_CLOSE";
export const SET_VISIBLE_MARKERS = "SET_VISIBLE_MARKERS";
export function updateSelectedAgentData(selectAgentData) {
  return {
    type: UPDATE_SELECTED_AGENT_DATA,
    selectAgentData,
  };
}
export function updateAllAgentData(allAgentData) {
  return {
    type: UPDATE_ALL_AGENT_DATA,
    allAgentData,
  };
}
export function updateListOnMap(listData) {
  return {
    type: UPDATE_MAP_LIST_DATA,
    listData,
  };
}
export function updateAgentsProperties(agentpropertyData) {
  return {
    type: UPDATE_AGENTS_PROPERTY_DATA,
    agentpropertyData,
  };
}
export function updateSelectedProperty(selectedprop) {
  return {
    type: UPDATE_PROPERTY_DATA,
    selectedprop,
  };
}
export function updateSelectedMarker(selectedmarker) {
  return {
    type: UPDATE_MARKER_PROPERTY_DATA,
    selectedmarker,
  };
}
export function setZoom(zoom) {
  return {
    type: SET_ZOOM,
    zoom,
  };
}
export function setCenter(center) {
  return {
    type: SET_CENTER,
    center,
  };
}
export function setRecommendationSuccess(recommendationSuccessStatus) {
  return {
    type: SET_RECOMMENDATION_SUCCESS,
    recommendationSuccessStatus,
  };
}
export function setAskAQuestionSuccess(askAQuestionSuccessStatus) {
  return {
    type: SET_ASK_A_QUESTION_SUCCESS,
    askAQuestionSuccessStatus,
  };
}
export function setReviewSuccess(reviewSuccessStatus) {
  return {
    type: SET_REVIEW_SUCCESS,
    reviewSuccessStatus,
  };
}

export function setSelectedMarkerAgentData(selectedMarkerAgentData) {
  return {
    type: SET_SELECTED_MARKER_AGENT_DATA,
    selectedMarkerAgentData,
  };
}
export function setOnClose(setonclose) {
  return {
    type: SET_ON_CLOSE,
    setonclose,
  };
}
export function setVisibleMarkers(visibleMarkers) {
  return {
    type: SET_VISIBLE_MARKERS,
    visibleMarkers,
  };
}
